var exports = {
  "Pm": "ConfirmationContainer__a9COTI",
  "i1": "confirmationTitle__QppjnX",
  "hR": "confirmationMessage__NTjYbp",
  "fc": "actionButtonsContainer__wf4ZO6",
  "LF": "pathText__pdrafF",
  "M8": "codeMargin__M92lX9",
};

module.exports = exports;
